import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

const CTASection = ({ onGetQuoteClick }) => {
  return (
    <section className="py-20 relative overflow-hidden" style={{background: 'linear-gradient(to right, #1a7a30, #2CC84B, #00BCD4)'}}>
      {/* Glowing orb decorations */}
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full blur-3xl opacity-20" style={{background: '#2CC84B'}} />
      <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full blur-3xl opacity-20" style={{background: '#00BCD4'}} />

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
        }} />
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Start Saving with Solar Today!
          </h2>
          <p className="text-xl md:text-2xl mb-8 opacity-95">
            Join 500+ happy customers who are reducing their electricity bills and contributing to a greener future
          </p>

          {/* Limited Time Offer */}
          <div className="bg-white/20 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-6 mb-8 inline-block">
            <p className="text-sm font-semibold mb-2 uppercase tracking-wider">Limited Time Offer</p>
            <p className="text-3xl font-bold mb-2">Get Additional ₹10,000 OFF</p>
            <p className="text-sm opacity-90">on installations booked this month + Free 5-year extended warranty</p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button
              onClick={onGetQuoteClick}
              size="lg"
              className="text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-black text-white border-0"
            >
              Get Your Free Consultation
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              onClick={() => window.open('tel:9011555048', '_self')}
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white text-lg px-8 py-6 transition-all duration-300 hover:bg-white" style={{'--hover-color': '#2CC84B'}} onMouseEnter={e => e.currentTarget.style.color='#2CC84B'} onMouseLeave={e => e.currentTarget.style.color='white'}
            >
              <Phone className="w-5 h-5 mr-2" />
              Call: 9011555048
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-8 text-sm opacity-90">
            <div className="flex items-center gap-2">
              <span className="text-2xl">✓</span>
              <span>No Hidden Costs</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">✓</span>
              <span>Free Site Survey</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">✓</span>
              <span>Same Day Response</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">✓</span>
              <span>25-Year Warranty</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
